export const X_API_KEY = process.env.REACT_APP_X_API_KEY;

// DOCS: Firebase environment specific configuration
export const FIREBASE_API_KEY = process.env.REACT_APP_FIREBASE_API_KEY;
export const FIREBASE_AUTH_DOMAIN = process.env.REACT_APP_FIREBASE_AUTH_DOMAIN;
export const FIREBASE_PROJECT_ID = process.env.REACT_APP_FIREBASE_PROJECT_ID;
export const FIREBASE_STORAGE_BUCKET =
  process.env.REACT_APP_FIREBASE_STORAGE_BUCKET;
export const FIREBASE_MESSAGING_SENDER_ID =
  process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID;
export const FIREBASE_APP_ID = process.env.REACT_APP_FIREBASE_APP_ID;
export const FIREBASE_MEASUREMENT_ID =
  process.env.REACT_APP_FIREBASE_MEASUREMENT_ID;

// DOCS: Recaptcha site key from env
export const RECAPTCHA_SITEKEY = process.env.REACT_APP_RECAPTCHA_SITEKEY;

// DOCS: Lo-hold environment specific configuration
export const LOHOLD_CLIENT_ID = process.env.REACT_APP_LOHOLD_CLIENT_ID;
export const LOHOLD_CLIENT_SECRET = process.env.REACT_APP_LOHOLD_CLIENT_SECRET;
export const LOHOLD_REDIRECT_URL = process.env.REACT_APP_LOHOLD_REDIRECT_URL;
export const LOHOLD_BASE_URL = process.env.REACT_APP_LOHOLD_BASE_URL;
export const LOHOLD_STATUS_FAILED = process.env.REACT_APP_LOHOLD_STATUS_FAILED;
export const LOHOLD_STATUS_SUCCESS =
  process.env.REACT_APP_LOHOLD_STATUS_SUCCESS;

// DOCS: KYC environment specific configuration
export const DL_KYC_CLIENT_ID = process.env.REACT_APP_DL_KYC_CLIENT_ID;
export const DL_KYC_CLIENT_SECRET = process.env.REACT_APP_DL_KYC_CLIENT_SECRET;
export const DL_KYC_REDIRECT_URL = process.env.REACT_APP_DL_KYC_REDIRECT_URL;
export const DL_KYC_BASE_URL = process.env.REACT_APP_DL_KYC_BASE_URL;
export const DL_KYC_STATUS_FAILED = process.env.REACT_APP_DL_KYC_STATUS_FAILED;
export const DL_KYC_STATUS_SUCCESS =
  process.env.REACT_APP_DL_KYC_STATUS_SUCCESS;

export const DOCUMENT_UPLOAD_BUCKET =
  process.env.REACT_APP_DOCUMENT_UPLOAD_BUCKET;

export const REPAY_RAZORPAY_KEY = process.env.REACT_APP_REPAY_RAZORPAY_KEY;

export const GPS_BUCKET_NAME = process.env.REACT_APP_GPS_BUCKET;
export const GPS_BUCKET_FOLDER = process.env.REACT_APP_GPS_BUCKET_FOLDER_NAME;
